export default {
  entidades: 'Jach\'a utanaka',
  configuracion: 'Configuraciones',
  usuarios: 'Atamiri jaqi',
  modulos: 'Módulos y permisos',
  roles: 'Roles',
  parametros: 'Preferencias',
  logs: 'Logs del sistema',
  config: 'Configuraciones'
};



// WEBPACK FOOTER //
// ./src/common/lang/ay/menu.js